export const setupDevtoolsPlugin = () => {}